import './index.css';

import * as Actions from '@/app/store/actions';

import { CircularProgress, useMediaQuery } from '@material-ui/core';
import { getRooms, getSingleRoomStream } from '@/app/services/liveStreaming/liveStreaming';
import { useEffect, useRef, useState } from 'react';

import { ChevronLeft } from '@material-ui/icons';
/* eslint-disable jsx-a11y/media-has-caption */
import FusePageSimple from '@/@fuse/core/FusePageSimple';
import LiveStreamingDrawer from './LivestreamingDrawer';
import SingleRoomStreaming from './SingleRoomStreaming';
import { Skeleton } from '@material-ui/lab';
import { useDispatch } from 'react-redux';

const LiveStreamingView = () => {
	const [rooms, setRooms] = useState([]);
	const [roomsLoading, setRoomsLoading] = useState(true);
	const [streamDataLoading, setStreamDataLoading] = useState(true);
	const [selectedRoomStreamData, setSelectedRoomStreamData] = useState(null);
	const [selectedRoomId, setSelectedRoomId] = useState(null);
	const [selectedRoomData, setSelectedRoomData] = useState(null);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const containerRef = useRef(null);
	const showFixedDrawer = useMediaQuery('(min-width:1280px)');
	const dispatch = useDispatch();
	const pageLayout = useRef(null);
	const [hasStreamData, setHasStreamData] = useState(false);

	useEffect(() => {
		let isMounted = true;
		setRoomsLoading(true);

		const fetchRooms = async (page = 1, allRooms = []) => {
			try {
				const res = await getRooms('', '', page, 0);
				if (isMounted) {
					const newRooms = [...allRooms, ...res.data.data];

					if (page < res.data.last_page) {
						fetchRooms(page + 1, newRooms);
					} else {
						setRooms(newRooms);
						setSelectedRoomId(newRooms[0].id);
						setSelectedRoomData(newRooms[0]);
						setRoomsLoading(false);
					}
				}
			} catch (error) {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch rooms',
						autoHideDuration: 2500,
						variant: 'error',
					})
				);
				if (isMounted) {
					setRoomsLoading(false);
				}
			}
		};

		fetchRooms();

		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		setStreamDataLoading(true);
		setHasStreamData(false);
		let isMounted = true;

		const fetchStreamData = async () => {
			try {
				const res = await getSingleRoomStream(selectedRoomId);
				if (isMounted) {
					setSelectedRoomStreamData(res.data.data);
					if (!res.data.error) {
						setHasStreamData(true);
					}
					setStreamDataLoading(false);
				}
			} catch (error) {
				if (isMounted) {
					dispatch(
						Actions.showMessage({
							message: error?.response?.data?.message || 'Failed to fetch stream data',
							autoHideDuration: 2500,
							variant: 'error',
						})
					);
					setHasStreamData(false);
					setStreamDataLoading(false);
				}
			}
		};

		if (selectedRoomId) {
			fetchStreamData();
		}

		return () => {
			isMounted = false; // Cleanup function to set isMounted to false
		};
	}, [selectedRoomId]);

	const handleRoomChange = (e, v) => {
		setSelectedRoomData(v);
		setSelectedRoomId(v.id);
	};

	const handleToggleDrawer = () => {
		setDrawerOpen(!drawerOpen);
	};

	return (
		<FusePageSimple
			content={
				<div className=" pb-64 w-full">
					<br />

					<div className="flex">
						<div className="w-full">
							<div className="flex justify-between">
								<div className="flex items-start flex-col md:flex-row justify-center">
									{selectedRoomData ? (
										<h4 className="font-extrabold md:text-pd-lg flex">{selectedRoomData?.name}</h4>
									) : (
										<Skeleton className="p-0 flex m-0" height={32} width={200} />
									)}

									<span className="md:text-pd-lg md:ml-4" />
								</div>
								<div className="flex gap-16 items-center">
									{!showFixedDrawer ? (
										<button
											className="text-pd-blue font-bold flex items-center"
											onClick={handleToggleDrawer}
											type="button"
										>
											<ChevronLeft className="mb-4" />
											Select Room
										</button>
									) : null}
								</div>
							</div>

							<div className={`mt-20 w-full max-w-3xl ${showFixedDrawer ? ' pr-288' : ''}`} ref={containerRef}>
								{streamDataLoading ? (
									<div className="relative">
										<video className="rounded-lg video-player object-fill" />
										<div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
											<CircularProgress />
										</div>
									</div>
								) : !streamDataLoading && hasStreamData ? (
									selectedRoomStreamData && <SingleRoomStreaming streamData={selectedRoomStreamData} />
								) : (
									<div className="relative">
										<video className="rounded-lg video-player object-fill" />
										<div className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-white">
											No stream data available
										</div>
									</div>
								)}
							</div>
						</div>
					</div>

					<LiveStreamingDrawer
						handleRoomChange={handleRoomChange}
						isLoading={roomsLoading}
						open={drawerOpen}
						rooms={rooms}
						selectedRoomId={selectedRoomId}
						setOpen={setDrawerOpen}
						setSelectedRoomId={setSelectedRoomId}
						showFixedDrawer={showFixedDrawer}
					/>
				</div>
			}
			innerScroll
			ref={pageLayout}
		/>
	);
};

export default LiveStreamingView;
